import React, { useState, useEffect } from 'react';
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from '../../../../components/Spinner'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { fetchTermsAndConditionsVersions, termsAndCondSaveDraft, termsAndCondPublishDraft, termsAndCondDeleteVersion } from '../../../../../redux/actions/admin';
//table
import { Table } from 'reactstrap';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import TandCModal from './Modal';

import styled from "styled-components";
import xIcon from 'web/assets/images/XIcon.png';
import ViewTerms from 'web/assets/images/view-terms.png';
import DeleteTerms from 'web/assets/images/delete-terms.png';

function TermsAndConditions() {
    const dispatch = useDispatch();
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [view, setView] = useState('listMode')
    const [basicModal, setBasicModal] = useState(false);
    const [basicModalMessage, setBasicModalMessaage] = useState('')
    const [basicModalType, setBasicModalType] = useState('')
    const [finalData, setFinalData] = useState([])
    const [draftData, setDraftData] = useState([])
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [tandCModal, setTandCModal] = useState(false);
    const [tandcModalContent, setTandcModalContent] = useState('');
    const [draftTitle, setDraftTitle] = useState();
    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        fetchMyAPI();
    }, []);

    const fetchMyAPI = async () => {
        let response = '';
        response = await dispatch(fetchTermsAndConditionsVersions());
        if (response.status === 200 && response.data) {
            let tempDataList = response.data?.filter(item => (item.published && !item.delete))
            let tempDraftDataList = response.data?.filter(item => !item.published)
            setFinalData(tempDataList.reverse())
            setDraftData(tempDraftDataList)
        } else {
            if (response.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setBasicModalMessaage(response.data?.message || response.message || 'Something went wrong, please try again.')
                setBasicModal(!basicModal)
            }
        }
    };

    // table header
    let headerArr = [
        { title: 'S. No.', },
        { title: 'Title', },
        { title: 'Version', },
        { title: 'Published Date', },
        { title: 'Actions', },
    ];

    const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }
    const disabledButtonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', opacity: 0.5 }

    const createMarkupForPageContent = () => {
        if (tandcModalContent) return { __html: tandcModalContent }
    }

    const saveDraft = async (draftContent, draftTitle, userRole) => {
        let data = {
            id: draftData[0]?.id,
            content: draftContent ? draftContent : draftData[0]?.content,
            tcversion: draftData[0]?.tcversion,
            title: draftTitle,
            type: userRole
        }
        let response = '';
        response = await dispatch(termsAndCondSaveDraft(data));
        if (response.status === 'SUCCESS') {
            fetchMyAPI()
            setBasicModalMessaage(response.message)
            setBasicModal(!basicModal)
        } else if (response.statusCode === 401) {
            history.push('/sign-in')
            window.location.reload(false);
        } else {
            setBasicModalMessaage(response.data?.message || response.message || 'Something went wrong, please try again.')
            setBasicModal(!basicModal)
        }
    }

    const publishDraft = () => {
        setBasicModalMessaage('Do you want to publish?')
        setBasicModal(!basicModal)
        setBasicModalType('fromPublish')
    }

    const publishDraftConfirm = async () => {
        setBasicModalType('')
        let id = draftData[0]?.id
        let response = '';
        response = await dispatch(termsAndCondPublishDraft(id));
        if (response.status === 'SUCCESS') {
            fetchMyAPI()
            setBasicModalMessaage(response.message)
            setBasicModal(true)
            
        } else if (response.statusCode === 401) {
            history.push('/sign-in')
            window.location.reload(false);
        } else {
            setBasicModalMessaage(response.data?.message || response.message || 'Something went wrong, please try again.')
            setBasicModal(!basicModal)
        }
    }

    const delateTandCVersion = async (id) => {
        let response = '';
        response = await dispatch(termsAndCondDeleteVersion(id));
        if (response.status === 'SUCCESS') {
            fetchMyAPI()
            setBasicModalMessaage(response.message)
            setBasicModal(!basicModal)
        } else if (response.statusCode === 401) {
            history.push('/sign-in')
            window.location.reload(false);
        } else {
            setBasicModalMessaage(response.data?.message || response.message || 'Something went wrong, please try again.')
            setBasicModal(!basicModal)
        }
    }

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('NEW_INVITATIONS'))) ?
                <>
                    {view === 'listMode' &&
                        <TableWrapper>
                            {loaderVisible && <Spinner />}
                            <Heading>
                                <h3>Manage Terms and Conditions</h3>
                                <div className='d-flex flex-wrap flex-sm-nowrap'>
                                    <button
                                        style={buttonStyle}
                                        onClick={() => {
                                            setTandCModal(true)
                                            setTandcModalContent(draftData[0]?.content)
                                            setDraftTitle(draftData[0]?.title)
                                        }}>
                                        Draft
                                    </button>
                                    <button
                                        style={draftData[0]?.title ? buttonStyle : disabledButtonStyle}
                                        disabled={draftData[0]?.title ? false : true}
                                        onClick={() => publishDraft()}>
                                        Publish
                                    </button>
                                </div>
                            </Heading>

                            <Table responsive>
                                <thead>
                                    <tr>
                                        {headerArr.map((items, index) => (
                                            <th key={index}>{items.title}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        finalData.map((items, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{items.title}</td>
                                                <td>{items.tcversion}</td>
                                                <td>{items.publishDateTime ? moment(items.publishDateTime).format("MM/DD/YYYY") : ''}</td>
                                                <td>
                                                    <img title='View' src={ViewTerms} className="ViewTerms" alt="view-icon"
                                                        onClick={() => {
                                                            setView('viewMode')
                                                            setTandcModalContent(items.content)
                                                        }} />
                                                    {index !== 0 &&
                                                        <img title='Delete' src={DeleteTerms} className="DeleteTerms" alt="delete-icon"
                                                            style={{ marginLeft: '15px' }}
                                                            onClick={() => {
                                                                delateTandCVersion(items.id)
                                                            }} />
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>

                            <Modal isOpen={basicModal} centered={true}>
                                <ModalBody style={{ textAlign: 'center' }}>
                                    {basicModalMessage}
                                </ModalBody>
                                <ModalFooter style={{ justifyContent: 'center' }}>
                                    <Button color="primary" onClick={() => {
                                        setBasicModal(!basicModal)
                                        if (basicModalType === 'fromPublish') publishDraftConfirm()
                                    }}>OK</Button>
                                    {basicModalType === 'fromPublish' &&
                                        <Button color="primary" onClick={() => {
                                            setBasicModal(!basicModal)
                                            setBasicModalType('')
                                        }}>Cancel</Button>
                                    }
                                </ModalFooter>
                            </Modal>
                        </TableWrapper>}
                    {
                        view === 'viewMode' &&
                        <Container>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <p></p>
                                <h3>Operational T&Cs</h3>
                                <img className='xIcon' src={xIcon} alt="X-Icon"
                                    onClick={() => setView('listMode')}
                                />
                            </div>
                            <TermText>
                                <div dangerouslySetInnerHTML={createMarkupForPageContent()} />
                            </TermText>
                        </Container>
                    }
                </>
                :
                <p>You are not authorized to view this page.</p>
            }
            <TandCModal
                isOpen={tandCModal}
                toggle={() => setTandCModal(!tandCModal)}
                content={tandcModalContent}
                draftTitleVal={draftTitle}
                link={''}
                acknowledgeCallBack={(content, draftTitle, type, userRole) => {
                    if (type === 'edited') saveDraft(content, draftTitle, userRole)
                }}
            />
        </>
    )

}

export default TermsAndConditions

const Container = styled.div`
  max-width: 1411px;
  padding: 50px 85px;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding: 15px;
  }
  h3 {
    font-family: "latobold";
    text-align: center;
  }
`;
const TermText = styled.div`
  padding: 15px 0;
  margin-top: 15px;
  p {
    text-align: justify;
  }
`;